export default {

    LOAD_CUSTOMER_PROFILE(state, customer_profile) {
        state.items = customer_profile;
    }

}